import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router";
import styles from './Header.scss';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import Navigation from 'components/common/Navigation';
import MyInfoModal from './MyInfoModal';
import { COMPANY_TYPE, CE_TYPE } from 'constant';
import { text_companyNm } from 'lib/textChang';

const cx = classNames.bind(styles);

class Header extends Component {
	state = {
		myInfoVisible: false
  };
  
	render() {
		const { sessionLoginInfo, onLogout, onViewMode } = this.props;
    const { myInfoVisible } = this.state;
    const menuOn = (url) => {
      return (this.props.location.pathname.lastIndexOf(url) >= 0) ? "on" : "" ;
    };
    return (
		<Fragment> 
			<header className = {cx('header')}>
				<div className = {cx('header-content')}>
					<div className = {cx('logo')}>
						{(sessionLoginInfo.cGbn === COMPANY_TYPE.KNP)
							&& <Link to = "/">YUJIN S&A (국립공원공단 근무복관리 시스템)</Link>}
						{(sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ)
							&& <Link to = "/">YUJIN S&A (벤츠 근무복관리 시스템)</Link>}
					</div>
					<div className={cx('margin-left-auto')}>
						<ul>
							<li onClick = {()=>this.setState({myInfoVisible: true})}>
								<div className = {cx('profile')}>
									<div className = {cx('profile-img')}></div>
									<div className = {cx('user-name')}>
										{sessionLoginInfo?.ceNm && 
                    <Fragment>
                      <span style={{ color: '#1890ff', margin: '0px 10px' }}>{sessionLoginInfo.ceNm}</span>님
                    </Fragment>}
									</div>
								</div>
							</li>
              <li onClick={()=>onViewMode('list')}>
								<Navigation to ='/notice' theme=''>
									<div className = {cx('topmenu')}>
										<div className = {cx('topmenu_gr')}>공지사항</div>
									</div>
								</Navigation>
							</li>
							{(sessionLoginInfo.cGbn === COMPANY_TYPE.KNP) &&
								<li onClick={()=>onViewMode('list')}>
									<Navigation to ='/qnaBoard' theme=''>
										<div className = {cx('topmenu')}>
											<div className = {cx('topmenu_gr')}>Q & A</div>
										</div>
									</Navigation>
								</li>
							}
							<li onClick={onLogout}>
								<div className = {cx('logout')}>
									<div className = {cx('log_gr')}>로그아웃</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div className = {cx('header-content head_nav ')}>
					<Fragment>         
            <Navigation to ='/orderManage' theme={menuOn('/orderManage')}>근무복주문</Navigation>
            <Navigation to ='/transManage' theme={menuOn('/transManage')}>주문관리</Navigation>
            <Navigation to ='/transHistory' theme={menuOn('/transHistory')}>구매이력</Navigation>

            {/* <Navigation to ='/settleManage' theme={menuOn('/settleManage')}>정산관리</Navigation> */}
            {/* <Navigation to ='/userManage' theme={menuOn('/userManage')}>사원관리</Navigation> */}
            {/* <Navigation to ='/jobManage' theme={menuOn('/jobManage')}>직무관리</Navigation> */}
            {/* <Navigation to ='/goodsJobManage' theme={menuOn('/goodsJobManage')}>상품이용정보관리</Navigation> */}

            {(sessionLoginInfo.ceType === CE_TYPE.MASTER
							|| (sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ && sessionLoginInfo.ceType === CE_TYPE.BRANCH))
            && <Fragment>
                <Navigation to ='/centerManage' theme={menuOn('/centerManage')}>
									{text_companyNm()}관리
								</Navigation>
                <Navigation to ='/goodsManage' theme={menuOn('/goodsManage')}>상품관리</Navigation>
                <Navigation to ='/stats' theme={menuOn('/stats')}>통계</Navigation>
              </Fragment>
            }

            {/* 유진관리자 */}
            {sessionLoginInfo.ceType === CE_TYPE.YUJIN
            && <Fragment>
                <Navigation to ='/orderReturn' theme={menuOn('/orderReturn')}>반품관리</Navigation>
                <Navigation to ='/centerManage' theme={menuOn('/centerManage')}>
									{text_companyNm()}관리
								</Navigation>
                <Navigation to ='/goodsManage' theme={menuOn('/goodsManage')}>상품관리</Navigation>
                <Navigation to ='/goodsGroupManage' theme={menuOn('/goodsGroupManage')}>상품군관리</Navigation>
                <Navigation to ='/stats' theme={menuOn('/stats')}>통계</Navigation>
                <Navigation to ='/companyManage' theme={menuOn('/companyManage')}>유진정보관리</Navigation>
              </Fragment>
            }

            <Navigation to ='/companyInfo' theme={menuOn('/companyInfo')}>YUJIN S&A</Navigation>
          </Fragment>
					
				</div>
			</header>

			<MyInfoModal
				modalOpen={myInfoVisible}
				modalClose={()=>this.setState({myInfoVisible: false})}
				sessionLoginInfo={sessionLoginInfo}
			/>
		</Fragment>
		);
	}
}


export default withRouter(Header);